/**
 * List/dashboard projection of a work order. Keeps the fields needed to
 * render the alerts table and decide visibility, without partNumbers/production.
 */
export function toLiteWorkOrder(workOrder) {
    if (!workOrder) return null
    const attachments = Array.isArray(workOrder.attachments)
        ? [...workOrder.attachments]
        : []
    return {
        id: workOrder.id,
        code: workOrder.code || workOrder.id,
        projectId: workOrder.projectId,
        createdBy: workOrder.createdBy,
        projectManager: workOrder.projectManager,
        status: workOrder.status,
        attachments,
        assemblyWorkOrder: !!workOrder.assemblyWorkOrder,
    }
}

export function workOrderLooksFull(workOrder) {
    return !!(workOrder && workOrder.partNumbers)
}
